import MenuService from "@/core/components/menu/MenuService";
import MenuItem from "@/core/components/menu/MenuItem";
import i18n from '@/shared/i18n'
import Dpv from './Dpv.vue'

const routes = [
  {
    path: 'dpv',
    name: 'dpv',
    component: Dpv,
    meta: {
      requiresAuth: true
    }
  }
];

MenuService.addMenuItem(new MenuItem('/dpv', i18n.t('DPV History'), 4, 'file', [], 'view_auction'));

export {routes}
